
import  { createSwitchNavigator, createAppContainer  }  from 'react-navigation';

import './index.css';
import Home from './Home';



const AppNavigator = createSwitchNavigator({


Home: { screen: Home, navigationOptions: { title: 'Home', header: null  }, path: 'Home' },


})

export default createAppContainer(AppNavigator);